//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//data
import dataSiteMap from '../../siteMap.json';

//assets
import './navContent.css';

//functions
import * as Utilities from '../../utilities';

class NavContent extends Component {
	constructor() {
		super();

		this.state = {
			navOpen: false,
			timeout: null,
		};

		this.navClose = this.navClose.bind(this);
		this.navToggle = this.navToggle.bind(this);
	}

	navClose(event) {
		const links = this.refs.links;
		const linksInner = this.refs.linksInner;
		const _this = this;

		links.style.height = linksInner.clientHeight + 'px';

		clearTimeout(this.state.timeout);

		this.setState({
			navOpen: false,
			timeout: setTimeout(function() {
				links.style.height = 0;

				_this.setState({
					timeout: setTimeout(function() {
						links.removeAttribute('style');
					}, 500),
				});
			}, 0),
		});
	}

	navToggle() {
		const links = this.refs.links;
		const linksInner = this.refs.linksInner;
		const _this = this;

		if (this.state.navOpen) {
			links.style.height = linksInner.clientHeight + 'px';

			clearTimeout(this.state.timeout);

			this.setState({
				timeout: setTimeout(function() {
					links.style.height = 0;

					_this.setState({
						timeout: setTimeout(function() {
							links.removeAttribute('style');
						}, 500),
					});
				}, 0),
			});
		} else {
			links.style.height = 0;
			links.style.maxHeight = 'none';

			clearTimeout(this.state.timeout);

			this.setState({
				timeout: setTimeout(function() {
					links.style.height = linksInner.clientHeight + 'px';

					_this.setState({
						timeout: setTimeout(function() {
							links.style.height = 'auto';
						}, 500),
					});
				}, 0),
			});
		}

		this.setState({
			navOpen: !this.state.navOpen,
		});
	}

	render() {
		const culture = this.props.culture;
		const section = this.props.section;
		const page = this.props.page;

		try {
			const navDescription = dataSiteMap[culture].navigation[section].description;

			const navItems = dataSiteMap[culture].navigation[section].pages.map((record, index) => {
				if (!record.live) {
					return null;
				}

				let pageMatch = page === record.key;
				let recordMatch = record.key === 'prescribing-information';
				let pathUK = window.location.pathname.includes('/uk/');

				let ukPi = recordMatch === true && pathUK === true;	
				let linkClass = 'nav-content__link';
				let linkTo = '/' + this.props.culture + '/' + section + '/' + record.key;
				
				if (pageMatch) {
					linkClass += ' nav-content__link--selected';
				}
				
				if (ukPi){
					return (
						<span>

							<a className={linkClass} hrefLang={dataSiteMap[culture].cultureCode} key={index} onClick={this.navClose} href="https://www.emcpi.com/pi/35366  " >Great Britain Prescribing Information</a>
							<a className={linkClass} hrefLang={dataSiteMap[culture].cultureCode} key={index} onClick={this.navClose} href="https://www.emcpi.com/pi/ni/394"  >Northern Ireland Prescribing Information</a>
						</span>
					)
				}

				return (
					<Link className={linkClass} hrefLang={dataSiteMap[culture].cultureCode} key={index} onClick={this.navClose} to={linkTo} dangerouslySetInnerHTML={{__html: record.__htmlName}} />
				);
			});

			let burgerClass = 'burger';

			if (this.state.navOpen) {
				burgerClass += ' burger--active';
			}

			return (
				<nav className="nav-content">
					<div className="nav-content__header container__row container__row--small">
						<div className="container__column">
							<div className="nav-content__description">{Utilities.removeWidow(navDescription)}</div>
						</div>
						<div className="container__column">
							<button className={burgerClass} onClick={this.navToggle} ref="burger">
								<div className="burger__item burger__item--bun-top"></div>
								<div className="burger__item burger__item--patty"></div>
								<div className="burger__item burger__item--bun-bottom"></div>
							</button>
						</div>
					</div>
					<div className="nav-content__links" ref="links">
						<div className="nav-content__links__inner" ref="linksInner">
							{navItems}
						</div>
					</div>
				</nav>
			);
		} catch (error) {
			console.log('No section navigation within this section');
		}

		return null;
	}
}

export default NavContent;



// WEBPACK FOOTER //
// ./src/components/navContent/navContent.js